module.exports = __webpack_public_path__ + "static/media/image.e224864d.png";